/**
 * Erreurs du modele de coffre. Ce paquet ne manipule jamais de secret en clair
 * (les `secrets` d'une entree/dossier ne sont lus qu'apres dechiffrement par
 * `@klavox/crypto-core`, hors de ce module) : ses erreurs ne portent donc que
 * sur la forme des enregistrements (id, revision, horodatage, type).
 */
export class VaultModelError extends Error {
  constructor(message: string) {
    super(message);
    this.name = new.target.name;
  }
}

/** Argument absent, mal type, ou enregistrement mal forme. */
export class InvalidVaultModelInputError extends VaultModelError {}
